/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetBbsContentGroupByCategoryRespVo } from './GetBbsContentGroupByCategoryRespVo';
import {
    GetBbsContentGroupByCategoryRespVoFromJSON,
    GetBbsContentGroupByCategoryRespVoFromJSONTyped,
    GetBbsContentGroupByCategoryRespVoToJSON,
    GetBbsContentGroupByCategoryRespVoToJSONTyped,
} from './GetBbsContentGroupByCategoryRespVo';

/**
 * 
 * @export
 * @interface ResponseListGetBbsContentGroupByCategoryRespVo
 */
export interface ResponseListGetBbsContentGroupByCategoryRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListGetBbsContentGroupByCategoryRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListGetBbsContentGroupByCategoryRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<GetBbsContentGroupByCategoryRespVo>}
     * @memberof ResponseListGetBbsContentGroupByCategoryRespVo
     */
    data?: Array<GetBbsContentGroupByCategoryRespVo>;
}

/**
 * Check if a given object implements the ResponseListGetBbsContentGroupByCategoryRespVo interface.
 */
export function instanceOfResponseListGetBbsContentGroupByCategoryRespVo(value: object): value is ResponseListGetBbsContentGroupByCategoryRespVo {
    return true;
}

export function ResponseListGetBbsContentGroupByCategoryRespVoFromJSON(json: any): ResponseListGetBbsContentGroupByCategoryRespVo {
    return ResponseListGetBbsContentGroupByCategoryRespVoFromJSONTyped(json, false);
}

export function ResponseListGetBbsContentGroupByCategoryRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListGetBbsContentGroupByCategoryRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetBbsContentGroupByCategoryRespVoFromJSON)),
    };
}

export function ResponseListGetBbsContentGroupByCategoryRespVoToJSON(json: any): ResponseListGetBbsContentGroupByCategoryRespVo {
    return ResponseListGetBbsContentGroupByCategoryRespVoToJSONTyped(json, false);
}

export function ResponseListGetBbsContentGroupByCategoryRespVoToJSONTyped(value?: ResponseListGetBbsContentGroupByCategoryRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetBbsContentGroupByCategoryRespVoToJSON)),
    };
}

